import SCOOTER_BASIC_MARKER from '../../../assets/kickboard.svg'
import BIKE_BASIC_MARKER from '../../../assets/bike.svg'
import MOPED_BASIC_MARKER from '../../../assets/moped.svg'

export const MarkerImages = {
  SCOOTER_BASIC_MARKER,
  BIKE_BASIC_MARKER,
  MOPED_BASIC_MARKER,
}
